module.exports = __webpack_public_path__ + "static/Celluloid-d96d2a90d5e77d40f567c16553d20d38.jpeg";